export const TestHooks = {
	BuyerAgentOrBrokerageSideForm: 'buyer-agent-or-brokerage-side-form',
	SellerAgentOrBrokerageSideForm: 'seller-agent-or-brokerage-side-form',
	BuyerSaleClientsSearchAndCreate: 'buyer-sale-clients-search-and-create',
	SellerSaleClientsSearchAndCreate: 'seller-sale-clients-search-and-create',
	PropertyDetailsContainer: 'property-details-container',
	DepositHolderDropdown: 'deposit-holder-dropdown',
	VtbMortgageExistsSwitch: 'vtb-mortgage-exists-switch',
} as const;
